module.exports = __webpack_public_path__ + "img/lacrosse-stick.f06fe0e4.svg";